import { actions, selectors } from './';
import PropTypes from 'prop-types';
import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
import ProgressBar from '../../modules/shared/progress-bar';
import UnderMaintenancePopup from './components/under-maintenance-popup';
import Error from '../../modules/shared/error';

import LoginForm from './components/login-form';
import SystemNotificationPopup from './components/converter-popup';
import RegisterForm from './components/register-form';
import LoadingSpinner from './components/loading-spinner';
import PopupWindow from './components/popup-window';
import YearResultsPopup from './components/year-results-popup';

const Main = props => {
	switch (true) {
		case uninitialized(props): return <FetchData {...props}/>;
		case hasData(props): return Render(props);
		case shouldRegister(props): return RenderRegister(props);
		case shouldLogin(props): return RenderLogin(props);
		case hasError(props): return RenderError(props);
		default: throw new Error('Undefined state');
	}
};

// predicates
const uninitialized = props => {
	return !hasError(props) && (isNull(props.userData) || isNull(props.lists)) && !props.shouldLogin;
};
const hasData = props => !hasError(props) && (!isEmpty(props.userData) || !isEmpty(props.lists));
const shouldRegister = props => !hasData(props) && props.shouldRegister;
const shouldLogin = props => !hasData(props) && props.shouldLogin;
const hasError = props => !!props.error;

// functions
class FetchData extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isMaintenancePopupVisible: false };
	}

	componentDidMount() {
		axios.get('/v2/lists/get-system-state')
			.then(data => {
				if (data.data && data.data.state === 'maintenance') {
					this.setState({ isMaintenancePopupVisible: true });
				}
			});
	}

	render() {
		this.props.fetchAppData();
		if (this.state.isMaintenancePopupVisible) {
			return <UnderMaintenancePopup {...this.props} />;
		}

		return <ProgressBar isAppInitProgressBar={true} />;
	}
}
const RenderError = props => <Error {...props} />;
const RenderLogin = props => <LoginForm {...props} />;
const RenderRegister = props => <RegisterForm {...props} />;

const isRocket = process.env.CPA_ENV === 'rocket';

const Render = props => {

	document.title = props.intl('Партнёрская сеть %s', !isRocket ? 'Everad' : 'RocketProfit');

	const Layout = props.layout;

	const isYearResultsShowed = isRocket
		&& props.location.pathname === '/dashboard/week-chart/'
		&& props.location.query.o === 'year-results';

	return (
		<div>
			<SystemNotificationPopup {...props}/>
			<Layout {...props} />
			{ props.shouldShowLoadingSpinner && <LoadingSpinner /> }

			{!isYearResultsShowed && props.popup && (
				<PopupWindow
					popup={props.popup}
					closePopup={props.closePopup}
				/>
			)}

			<YearResultsPopup isShowed={isYearResultsShowed} />
		</div>
	);

};

Render.propTypes = {
	layout: PropTypes.element,
	intl: PropTypes.func,
	shouldShowLoadingSpinner: PropTypes.bool
};

FetchData.propTypes = {
	fetchAppData: PropTypes.func
};

export default connect(
	state => ({
		userData: selectors.getUserData(state),
		popup: selectors.getPopup(state),
		appConfig: selectors.getAppConfig(state),
		lists: selectors.getLists(state),
		shouldLogin: selectors.getShouldLogin(state),
		shouldRegister: selectors.getShouldRegister(state),
		shouldShowLoadingSpinner: selectors.getShouldShowLoadingSpinner(state),
		intl: selectors.getIntl(state), // for make translate
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/main.js